<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import { appManager } from "../AppManager";

    const navigate = useNavigate();

    async function signin() {
        const to =
            (await appManager.completeSignin()) || "/";

        window.location.href = to;
//        navigate(to, { replace: true });
    }
</script>

{#await signin()}
    <div />
{/await}
